/**
 * Lekka lista 3 najnowszych artykułów dla strony głównej (bez treści artykułów,
 * żeby nie ładować ich na telefonach). Test latest-articles.test.ts pilnuje zgodności z articles.ts.
 */
export const latestArticles = [
  {
    "slug": "stawianie-granic-w-pracy",
    "h1": "Stawianie granic w pracy: jak być dostępnym liderem, nie będąc dostępnym bez przerwy?",
    "teaser": "Wiadomości po godzinach, szybkie pytania i decyzje, które ciągle wracają do Ciebie. Jak ustalić dostępność, żeby zespół wiedział, kiedy i z czym się zwracać.",
    "datePublished": "2026-10-13"
  },
  {
    "slug": "psychologia-przywodztwa",
    "h1": "Co presja robi z liderem? Psychologia przywództwa w praktyce",
    "teaser": "Psychologia przywództwa w praktyce: jak stres i przeciążenie zmieniają zachowanie lidera oraz co pomaga zachować jakość decyzji i relacji.",
    "datePublished": "2026-09-28"
  },
  {
    "slug": "konflikt-ze-wspolnikiem",
    "h1": "Konflikt ze wspólnikiem: kiedy spór o firmę staje się sporem o człowieka",
    "teaser": "Konflikt ze wspólnikiem nie musi oznaczać końca firmy. Zobacz, co eskaluje spór, jak oddzielić decyzje od relacji i kiedy warto skorzystać z mediacji.",
    "datePublished": "2026-09-21"
  }
] as const;
